<script setup lang="ts">
import profileIcon from '@/assets/img/icon/account/ic-profile-green.svg';
import AppTypography from '@/components/base/AppTypography.vue';
import { useAuthStore } from '../../store/auth';

const { getUserFullname, getCompanyName, getRole } = storeToRefs(useAuthStore());

const fullName = computed((): string => {
  return getUserFullname.value || 'NA';
});

const companyName = computed((): string => {
  return getCompanyName.value || 'NA';
});

const role = computed((): string => {
  return getRole.value || 'NA';
});
</script>
<template>
  <div class="account-profile">
    <div class="d-flex mb-2">
      <v-img :src="profileIcon" max-width="32" data-testid="profile-icon" class="mr-2" />
      <AppTypography type="title-1">{{ fullName }}</AppTypography>
    </div>
    <div class="d-flex">
      <AppTypography type="subheadline-2">{{ companyName }}</AppTypography>
      <AppTypography type="subheadline-2" class="mx-4">•</AppTypography>
      <AppTypography type="subheadline-2">{{ role }}</AppTypography>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.account-profile {
}
</style>
